import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../../services/IFilter";

export class SaUserFilter implements IFilter{

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(companyId:any) {
    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  departmentIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get departmentId():any {
    return this.departmentIdChange.value;
  }
  set departmentId(departmentId:any) {
    this.departmentIdChange.next(departmentId);
    this.emitChange("departmentId", departmentId);
  }

  regionIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get regionId():any {
    return this.regionIdChange.value;
  }
  set regionId(regionId:any) {
    this.regionIdChange.next(regionId);
    this.emitChange("regionId", regionId);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(name:any) {
    this.nameChange.next(name);
    this.emitChange("name", name);
  }

  usernameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get username():any {
    return this.usernameChange.value;
  }
  set username(username:any) {
    this.usernameChange.next(username);
    this.emitChange("username", username);
  }

  emailChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get email():any {
    return this.emailChange.value;
  }
  set email(email:any) {
    this.emailChange.next(email);
    this.emitChange("email", email);
  }

  msisdnChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get msisdn():any {
    return this.msisdnChange.value;
  }
  set msisdn(msisdn:any) {
    this.msisdnChange.next(msisdn);
    this.emitChange("msisdn", msisdn);
  }

  hasServiceChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get hasService():any {
    return this.hasServiceChange.value;
  }
  set hasService(val:any) {
    this.hasServiceChange.next(val);
    this.emitChange("hasService", val);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.departmentId && this.departmentId !== '') {
      params = params.set("departmentId", this.departmentId);
    }
    if (this.regionId && this.regionId !== '') {
      params = params.set("regionId", this.regionId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.username && this.username !== '') {
      params = params.set("username", this.username);
    }
    if (this.email && this.email !== '') {
      params = params.set("email", this.email);
    }
    if (this.msisdn && this.msisdn !== '') {
      params = params.set("msisdn", this.msisdn);
    }
    if (this.hasService && this.hasService !== '') {
      params = params.set("hasService", this.hasService);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId || undefined);
    this.departmentIdChange.next(props.departmentId || undefined);
    this.regionIdChange.next(props.regionId || undefined);
    this.usernameChange.next(props.username || undefined);
    this.nameChange.next(props.name || undefined);
    this.emailChange.next(props.email || undefined);
    this.msisdnChange.next(props.msisdn || undefined);
    this.hasServiceChange.next(props.hasService || undefined);
  }
  toObj() {
    let obj:any = {};
    obj.companyId = this.companyId;
    obj.departmentId = this.departmentId;
    obj.regionId = this.regionId;
    obj.username = this.username;
    obj.name = this.name;
    obj.email = this.email;
    obj.msisdn = this.msisdn;
    obj.hasService = this.hasService;
    return obj;
  }

  public clear():void {
    this.companyIdChange.next(undefined);
    this.departmentIdChange.next(undefined);
    this.regionIdChange.next(undefined);
    this.usernameChange.next(undefined);
    this.nameChange.next(undefined);
    this.emailChange.next(undefined);
    this.msisdnChange.next(undefined);
    this.hasServiceChange.next(undefined);
  }
}
